<template lang="pug">
  model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="Continuar"
        title="Crear promoción"
        :fields="fieldsComputed"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
    template( slot="header-actions" )
      v-btn( color="primary" @click="submitUPCCode" ) código upc
          v-icon refresh
      v-btn( color="primary" @click="submitInternalCode" ) código interno
          v-icon refresh
    //- template( slot="footer-actions" )
    //-     v-btn.ml-2( color="info" block @click="submit_goOut") Guardar y salir
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from './fields'
/* models */
import ProductModel from '@/models/Warehouse/WhProduct'
import PromoModel from './../../../../../models/Warehouse/WhPromo'
import ItemModel from '@/models/Warehouse/WhItem'
/* vuex */
import {mapActions} from 'vuex'
/* services */
import Translator from '@/services/translator'
import SubfamilyService from "@/services/api/subfamily/SubfamilyService"
export default {
  name: 'creat-product-general-information',
  props: {
    branchOfficeId:{
      type: Array,
      required: true,
    },
  },
  data: function(){
    return {
      formData: {},
      //formFields: this.fieldsComputed(),
      allowContinue: false,
      product: {},
      subfamilyItems:[],
      upcCodes: [],
    }
  },
  computed: {
    suggest_internal_code_params() {
        return {
            family_id: Number(this.formData.wh_family_id || 1),
            product_name: String(this.formData.name || ''),
            subfamily_id: Number(this.formData.wh_subfamily_id || 1),
        }
    },
    /*
     */
    fieldsComputed(){
      return FieldsCreate(this.$store.state.AuthModule.user.hr_employee.g_branch_office_id, this.upcCodes, this.subfamilyItems, this.triggerSubFamily)
    },
  },
  methods: {
    // -- UI Modification
    // -- UPC methods
    /*
     */
    submitUPCCode() {
        this.$refs.form.setWait(true).then(this.fetchUPCCode)
    },
    fetchUPCCode() {
            ProductModel.find('suggest_upc_code')
                .then(this.setUPCCode)
                .then(this.successUPCCode)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    /**
     *
     */
    setUPCCode(data) {
        this.setUPCCodeItems(data)
        this.setUPCCodeValue(data)
    },

    /**
     *
     */
    setUPCCodeItems(data) {
        this.upcCodes.push(data.suggested_code)
    },

    /**
     *
     */
    setUPCCodeValue(data) {
        if(!this.formData.upc_codes){
            this.formData.upc_codes=[data.suggested_code]
        }
        else{
            this.formData['upc_codes'].push(data.suggested_code)
        }
    },
    successUPCCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código UPC',
                message: 'Se agrego el código UPC sugerido.',
                timeout: 3000,
            })
    },
    // -- End UPC methods
    // -- Internal code 
    submitInternalCode() {
      this.$refs.form.setWait(true).then(this.fetchInternalCode)
    },
    fetchInternalCode() {
      console.log(this.formData,'formData')
      console.log(this.suggest_internal_code_params,'internalcode')
      ProductModel.params((this.suggest_internal_code_params))
          .find('suggest_internal_code')
          .then(this.setInternalCode)
          .then(this.successInternalCode)
          .catch(this.error)
          .then(this.$refs.form.setWait)
    },
    setInternalCode(data) {
      this.formData['internal_code'] = data.suggested_code
    },
    successInternalCode() {
            this.setSnackbar({
                type: 'info',
                title: 'Código interno',
                message: 'Se agrego el código interno sugerido.',
                timeout: 3000,
            })
        },
    // -- End Internal code
    // -- Create product
    submit() {
      this.setAllowContinue(true)
      this.$refs.form.setWait(true).then(this.submitGeneralStep)
    },
    // -- End Create product
    // -- Create and Update with empty structure.
    // submit_goOut() {
    //   this.$refs.form.setWait(true).then(this.createWithEmptyStructure(this.formData))
    // },
    /* 
    */
    submitGeneralStep(data){
      //this.$emit('generalInfo',data) 
      console.log(data,'before create')
      let branchData = this.getBranchOfficeData()
      data.products = this.formatArrProducts(data.products)
      let updateInfo = this.getUpdateInfo(data,branchData)
      console.log(updateInfo , 'UpdateInfo')
      let model = new PromoModel(updateInfo)
      model.toCreate()
      .save()
      .then(r=>this.responseSuccessSubmit(r))
      .catch(this.error)
      .then(this.$refs.form.setWait)
    },
    /*
     */
    /*
     */
    getBranchOfficeData(){
      let branchId= this.branchOfficeId
      return branchId.map(id=>{
        let branch={}
        branch.cost_price = 0
        branch.g_branch_office_id = id
        branch.gains_margin = 0
        branch.sale_price = 0
        //branch.warranty_days = 0
        branch.minimum_stock = 0
        branch.maximum_stock = 0
        branch.critical_stock = 0
        return branch
      })
    },
    /*
     */
    getUpdateInfo (data,branchData){
      return {
        ...data, 
        branch_office_data:branchData,
        warranty_days : 0,
        is_consumable : false,
        is_salable : false,
        is_tax_free :false,
        //hard code data
        is_inventoriable : false,
        is_repackaged : false,
        is_seasonal : false,
        uom_quantity : 1, 
        wh_unit_of_measurement_id:1,
        have_decimal_quantity : false,

      }
    },
    // -- End create and Update with empty structure.
    /*
     */
    successCreateUpdate(){
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Producto creada exitosamente',
          timeout: 3000,
      })
    },
    error(error) {
      //console.log(error,'error')
            this.setSnackbar({
                type: 'error',
                title: 'Error',
                message: Translator(PromoModel, error.response.data),
                timeout: 15000,
            })
        },
    reset() {
            this.formData = new PromoModel()
            this.formFields[0].props.items = []
        },
    redirectList(){
      this.$router.push('/products')
    },
    /*
     */
    setAllowContinue(val){
      this.allowContinue = val
    },
    /*
     */
    redirectTo(data){
      if(this.allowContinue){
        // when event is emitted in the father component changes tab
        this.$emit('generalInfo',data) 
      }
      else{
        this.redirectList()
      }
    },
    /*
     */
    formatArrProducts(products){
      return products.map( p=> {
        p.wh_product_id = p.id
        return p 
      })
    } , 
    /* 
     */
    responseSuccessSubmit(response){
      this.$emit('generalInfo',response)
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información Promoción creada exitosamente',
          timeout: 3000,
      })
     
    },
    triggerSubFamily(ctx){
      
      SubfamilyService.fetchAllSubfamilyByFamilyId(ctx.value.wh_family_id).then(response=>{
          if(response.length >0 ){
            this.subfamilyItems = response
            ctx.value.wh_subfamily_id = response[0].id
          }
          else{
            this.setSnackbar({
                type: 'warning',
                title: 'Sin Subfamilias',
                message: 'La Familia seleccionada no posee subfamilias.',
                timeout: 3000,
            })
          }
      })
        
    },
    // -- Data handling and transformations
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  // watch: {},
  components: {
    'model-form': ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  mounted() {
    this.reset()
  },
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>